import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem("cookie-consent");
        if (!consent) {
            const timer = setTimeout(() => {
                setIsVisible(true);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const acceptCookies = () => {
        localStorage.setItem("cookie-consent", "accepted");
        setIsVisible(false);
    };

    const declineCookies = () => {
        localStorage.setItem("cookie-consent", "declined");
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div
            style={{
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 9999,
                padding: "1rem",
                animation: "slideUp 0.5s ease-out forwards",
            }}
        >
            <style>{`
                @keyframes slideUp {
                    from { transform: translateY(100%); opacity: 0; }
                    to   { transform: translateY(0);    opacity: 1; }
                }
            `}</style>

            <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
                <div
                    style={{
                        background: "linear-gradient(135deg, #111111 0%, #1a1a1a 100%)",
                        border: "1px solid rgba(212, 175, 55, 0.35)",
                        borderRadius: "16px",
                        boxShadow: "0 -4px 40px rgba(0,0,0,0.6), 0 0 0 1px rgba(212,175,55,0.08)",
                        padding: "1.5rem 2rem",
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "1.25rem",
                    }}
                >
                    {/* Left: text */}
                    <div style={{ flex: "1 1 300px" }}>
                        <h3
                            style={{
                                margin: "0 0 0.4rem",
                                fontSize: "1rem",
                                fontWeight: 700,
                                color: "#D4AF37",
                                fontFamily: "'Outfit', sans-serif",
                                letterSpacing: "0.03em",
                                textTransform: "uppercase",
                            }}
                        >
                            Privacidad & Cookies 🍪
                        </h3>
                        <p
                            style={{
                                margin: 0,
                                fontSize: "0.85rem",
                                color: "#DBCE97",
                                lineHeight: 1.6,
                                fontFamily: "'Manrope', sans-serif",
                            }}
                        >
                            Utilizamos cookies propias y de terceros para mejorar tu experiencia,
                            analizar el tráfico y personalizar el contenido. Al hacer clic en
                            "Aceptar todas", consientes su uso.{" "}
                            <Link
                                to="/cookies"
                                style={{
                                    color: "#D4AF37",
                                    fontWeight: 600,
                                    textDecoration: "underline",
                                    textUnderlineOffset: "3px",
                                }}
                            >
                                Política de Cookies
                            </Link>
                            .
                        </p>
                    </div>

                    {/* Right: buttons */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "1rem",
                            flexWrap: "wrap",
                        }}
                    >
                        <button
                            onClick={declineCookies}
                            style={{
                                background: "transparent",
                                border: "1px solid rgba(212, 175, 55, 0.4)",
                                borderRadius: "10px",
                                padding: "0.55rem 1.3rem",
                                color: "#DBCE97",
                                fontSize: "0.82rem",
                                fontWeight: 600,
                                fontFamily: "'Outfit', sans-serif",
                                cursor: "pointer",
                                letterSpacing: "0.04em",
                                transition: "all 0.2s ease",
                            }}
                            onMouseEnter={e => {
                                e.currentTarget.style.borderColor = "#D4AF37";
                                e.currentTarget.style.color = "#D4AF37";
                            }}
                            onMouseLeave={e => {
                                e.currentTarget.style.borderColor = "rgba(212,175,55,0.4)";
                                e.currentTarget.style.color = "#DBCE97";
                            }}
                        >
                            Solo necesarias
                        </button>

                        <button
                            onClick={acceptCookies}
                            style={{
                                background: "linear-gradient(135deg, #D4AF37 0%, #b8962e 100%)",
                                border: "none",
                                borderRadius: "10px",
                                padding: "0.6rem 1.6rem",
                                color: "#0A0A0A",
                                fontSize: "0.82rem",
                                fontWeight: 700,
                                fontFamily: "'Outfit', sans-serif",
                                cursor: "pointer",
                                letterSpacing: "0.06em",
                                textTransform: "uppercase",
                                boxShadow: "0 4px 18px rgba(212, 175, 55, 0.35)",
                                transition: "all 0.2s ease",
                            }}
                            onMouseEnter={e => {
                                e.currentTarget.style.boxShadow = "0 6px 24px rgba(212,175,55,0.55)";
                                e.currentTarget.style.transform = "scale(1.03)";
                            }}
                            onMouseLeave={e => {
                                e.currentTarget.style.boxShadow = "0 4px 18px rgba(212,175,55,0.35)";
                                e.currentTarget.style.transform = "scale(1)";
                            }}
                        >
                            Aceptar todas
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;
